<!-- sqm 整改单 8D -->
<template>
  <h-list-page class="Rejects8dList_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" footer is-search @change-method="changeMethod">
      <h-area>
        <h-search :title="h_i18n('183b71ea034c2ae3dd53c4888ca8c843')">
          <h-input clearable v-model="searchData.eightdId" @change="changeNull(searchData.eightdId, 'eightdId')"></h-input>
        </h-search>
        
        <h-search :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
                searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''"
                @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
                @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
              max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
              <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
            <div v-if="plan.showMtlPlan && plan.MtlOver600" style="color: red;height: 20px;background-color: #fff;
                padding-top: 3px;">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('fb36f45f54ec9c9de745b566c6e60e25') }}</span>
            </div>
          </h-detail>
        </h-search>

        <h-search :title="h_i18n('901fcadda8a5683e7a83a0c811ff4382')">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
          </h-input>
        </h-search>
        
        <h-search :title="h_i18n('03490f3868798323211aa633194df2c1')">
          <h-select v-model="searchData.sybId" clearable filterable @change="changeNull(searchData.sybId, 'sybId')">
            <h-option v-for="item in data.sybAllList" :key="item.departmentId" :label="item.departmentName" :value="item.departmentId">
            </h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('f5aa174d5a4ea33ebdaf179919d9f4b3')">
          <h-select clearable v-model="searchData.happenAddress" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable
            @change="changeNull(searchData.happenAddress, 'happenAddress')">
            <h-option v-for="item in data.happenAddressList" :value="item.valueId" :label="item.valueName" :key="item.valueId"></h-option>
            <!-- <h-option value="1016" label="入厂检验"></h-option>
            <h-option value="1017" label="现场退次"></h-option>
            <h-option value="1226" label="型式实验"></h-option>
            <h-option value="1290" label="其他"></h-option>
            <h-option value="2052" label="市场抱怨"></h-option>
            <h-option value="2199" label="并联交互"></h-option>
            <h-option value="2157" label="工厂巡查"></h-option>
            <h-option value="2158" label="现场PPM连续2个月超标"></h-option> -->
          </h-select>
        </h-search>

        <h-search :title="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')">
          <h-select clearable v-model="searchData.eightdStatus" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable
            @change="changeNull(searchData.eightdStatus, 'eightdStatus')">
            <h-option value="1292" :label="h_i18n('4a35e03b857bf3cde759bb1390f1bbac')"></h-option>
            <h-option value="1293" :label="h_i18n('65e42fa4e113c64a4c6da7ebb7bf2aa1')"></h-option>
            <h-option value="1294" :label="h_i18n('7aaa551969e05fdeebf81e9865c2c813')"></h-option>
            <h-option value="1295" :label="h_i18n('fa73df47a9f7e88c23e4fb592b15b8a7')"></h-option>
            <h-option value="1357" :label="h_i18n('63360bb16bb52f1e2234603ea37e1002')"></h-option>
            <h-option value="1528" :label="h_i18n('bbb7f44a862c3875ae857cd080bc4c42')"></h-option>
            <h-option value="1529" :label="h_i18n('407c1ab8a02df55a0e0ce61180f76fb2')"></h-option>
            <h-option value="1530" :label="h_i18n('1b7679d158eaa255e35d80c65a56dec1')"></h-option>
            <h-option value="1531" :label="h_i18n('c6d38da672e5cc6f315b27ca61361f34')"></h-option>
            <h-option value="1532" :label="h_i18n('ac3a319d16af41c97653ccd0ac6e7e8f')"></h-option>
            <h-option value="1534" :label="h_i18n('65268b512a2c54379b200058df94490d')"></h-option>
            <h-option value="1535" :label="h_i18n('8aed3e417bf3464b2047043475c951ac')"></h-option>
            <h-option value="1536" :label="h_i18n('227803b7875fb91af7d3a0d8826b2770')"></h-option>
            <h-option value="1556" :label="h_i18n('b0a13d1082935b1ed383e40e4cb298f5')"></h-option>
            <h-option value="1557" :label="h_i18n('cf5cb17196114224bdb77eec5175c43c')"></h-option>
            <h-option value="1558" :label="h_i18n('60bd8705d63b21b483874cb9ce85a343')"></h-option>
            <h-option value="1559" :label="h_i18n('b78687d00c3cddc61ef7a691491f8a84')"></h-option>
          </h-select>
        </h-search>

        <h-search :title="h_i18n('37769e25fffd760203c860702167cd26')">
            <h-select v-model="searchData.appealStatus" clearable filterable @change="changeNull(searchData.appealStatus, 'appealStatus')">
              <h-option :label="h_i18n('31b88d82c7738269292a70555719d18d')" value="自动认可"></h-option>
              <h-option :label="h_i18n('fcbda1a3b9a1f991de0b81f94ee7365c')" value="供方认可"></h-option>
              <h-option :label="h_i18n('5cb424765cb101866f47ca115605ce3b')" value="待审核"></h-option>
              <h-option :label="h_i18n('9109d5ff67cfd588c1d5265d160a958f')" value="待终判"></h-option>
              <h-option :label="h_i18n('db6e70ed7144c383e800dd36fe849cdf')" value="终判通过"></h-option>
              <h-option :label="h_i18n('85d8dd6ea355bf679c4af04dc3c611c1')" value="终判不通过"></h-option>
            </h-select>
          </h-search>

        <h-search :title="h_i18n('696f5a978bbeb2b4db9f282e64662eb0')">
          <h-date-picker @change="TimeChange(searchData.inputDate, {start:'beginDateOne',end:'endDateOne'})" v-model="searchData.inputDate"
            type="daterange" :start-placeholder="h_i18n('a3e3b88377c8a2f34e0f9ef6e67dbe62')" :end-placeholder="h_i18n('12f1d7ef38af6326c94fd11688f5b453')" :clearable="clearAble" />
        </h-search>

        <h-search :title="h_i18n('2e0c3e85c35dd1c5ff2c19eea0176502')">
          <h-select clearable v-model="searchData.isMouldReason" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" filterable
            @change="changeNull(searchData.isMouldReason, 'isMouldReason')">
            <h-option value="1" :label="h_i18n('0a60ac8f02ccd2cf723f927284877851')"></h-option>
            <h-option value="0" :label="h_i18n('c9744f45e76d885ae1c74d4f4a934b2e')"></h-option>
          </h-select>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="data.tableLoading" @click="getInfo(true)">
            <template #icon>
              <search />
            </template>{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('f37dba0758deb9ad0bead5f15776dd35')" :is-left="0" :is-right="4" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <template v-for="item in data.btnListOfSqm" :key="item.code">
          <template v-if="item.code == 'mkhl_zg_zg_export'">
            <h-button @click="excleBtn()" :loading="data.exportLoading">
              <template #icon>
                <i class="iconfont icon-daochu"></i>
              </template>{{ h_i18n('55405ea6ff6fd823ffab7e6b10ddfa95') }}</h-button>
          </template>
        </template>
        <div class="tipBox_yellow">
          <img src="@/assets/img/tips-icon.png" class="tip-img" />
            {{ h_i18n('d17f22a7d4885ad074a6e11a63603990') }}
        </div>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" v-loading="data.tableLoading" height="540" @selection-change="listCheckBoxChange"
        border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 540px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" width="40"></el-table-column>
        <el-table-column prop="eightdId" :label="h_i18n('183b71ea034c2ae3dd53c4888ca8c843')" width="160">
          <template #default="{ row }">
            <span style="text-decoration: none;color:#2164F5; cursor: pointer;" @click="detailBtn(row)">{{ row.eightdId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sybName" :label="h_i18n('03490f3868798323211aa633194df2c1')" width="120"></el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" width="130">
        </el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')" width="200" class-name="textalignleft_style"></el-table-column>
        <el-table-column prop="materielCategoryName" :label="h_i18n('33ac341a8748c430f721aa43dcf9f3b6')" width="120">
          
        </el-table-column>
        <el-table-column prop="happenAddressName" :label="h_i18n('f5aa174d5a4ea33ebdaf179919d9f4b3')" width="140"></el-table-column>
        <el-table-column prop="source" :label="h_i18n('1ef222016beac05f890e7224fd6e68cb')" width="100">
          <template #default="{row}">
            <span v-if="row.source == '12'">{{ h_i18n('0a60ac8f02ccd2cf723f927284877851') }}</span>
            <span v-else-if="row.source == '11'">{{ h_i18n('c9744f45e76d885ae1c74d4f4a934b2e') }}</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column prop="eightdStatus" :label="h_i18n('3fea7ca76cdece641436d7ab0d02ab1b')" width="120" class-name="btn_cell_style">
          <template #default="{ row }">
            <el-tag v-if="row.eightdStatus == h_i18n('cea0671a77281d4923d26111191e4fd8')" type="success" size="small">{{row.rectifyStatusName}}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1292" size="small">{{ h_i18n('4a35e03b857bf3cde759bb1390f1bbac') }}</el-tag>
            
            <el-tag v-else-if="row.eightdStatus == 1293" type="warning" size="small">{{ h_i18n('65e42fa4e113c64a4c6da7ebb7bf2aa1') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1294" type="info" size="small">{{ h_i18n('7aaa551969e05fdeebf81e9865c2c813') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1295" type="danger" size="small">{{ h_i18n('fa73df47a9f7e88c23e4fb592b15b8a7') }}</el-tag>

            <el-tag v-else-if="row.eightdStatus == 1357" type="warning" size="small">{{ h_i18n('63360bb16bb52f1e2234603ea37e1002') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1528" type="info" size="small">{{ h_i18n('bbb7f44a862c3875ae857cd080bc4c42') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1529" type="danger" size="small">{{ h_i18n('407c1ab8a02df55a0e0ce61180f76fb2') }}</el-tag>

            <el-tag v-else-if="row.eightdStatus == 1530" type="warning" size="small">{{ h_i18n('1b7679d158eaa255e35d80c65a56dec1') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1531" type="info" size="small">{{ h_i18n('c6d38da672e5cc6f315b27ca61361f34') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1532" type="danger" size="small">{{ h_i18n('ac3a319d16af41c97653ccd0ac6e7e8f') }}</el-tag>

            <el-tag v-else-if="row.eightdStatus == 1534" type="warning" size="small">{{ h_i18n('65268b512a2c54379b200058df94490d') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1535" type="info" size="small">{{ h_i18n('8aed3e417bf3464b2047043475c951ac') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1536" type="danger" size="small">{{ h_i18n('227803b7875fb91af7d3a0d8826b2770') }}</el-tag>
            
            <el-tag v-else-if="row.eightdStatus == 1556" type="warning" size="small">{{ h_i18n('b0a13d1082935b1ed383e40e4cb298f5') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1557" type="info" size="small">{{ h_i18n('cf5cb17196114224bdb77eec5175c43c') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1558" type="danger" size="small">{{ h_i18n('60bd8705d63b21b483874cb9ce85a343') }}</el-tag>
            <el-tag v-else-if="row.eightdStatus == 1559" type="success" size="small">{{ h_i18n('b78687d00c3cddc61ef7a691491f8a84') }}</el-tag>

            <el-tag v-else type="info" size="small"></el-tag>
          </template>
        </el-table-column> 
        <el-table-column prop="inputDate" :label="h_i18n('696f5a978bbeb2b4db9f282e64662eb0')" width="120">
          <template #default="{row}">
            <span>{{ time(row.inputDate) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="happenDate" :label="h_i18n('1bbe6ebe11a361d576f88cda2d2e32b8')" width="120">
          <template #default="{row}">
            <span>{{ time(row.happenDate) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="isMouldReasonName" :label="h_i18n('2e0c3e85c35dd1c5ff2c19eea0176502')" width="100"></el-table-column> 
        <el-table-column prop="daySum" :label="h_i18n('6ae2774138bb01f104a2b991ecdbb874')" width="150"></el-table-column>
        <el-table-column prop="remainDay" :label="h_i18n('2f7abbd3855b7078d7eab7185ae8bf1f')" width="150"></el-table-column>
        <el-table-column prop="rectifySumMonth" :label="h_i18n('7fe0b5998a211f8e7639cc6b9c6907fa')" width="100"></el-table-column>
        <el-table-column prop="d8Date" :label="h_i18n('5b45f92ecdfe2b29d9ca0494605f6824')" width="170">
          <template #default="{row}">
            <span>{{ time(row.d8Date) }}</span>
          </template>
        </el-table-column> 
        <el-table-column prop="" :label="h_i18n('2b6bc0f293f5ca01b006206c2535ccbc')" width="80" class-name="btn_cell_style">
          <template #default="{row}">
            <h-button v-if="(data.roleCode == 'S009' || data.roleCode == 'S006') && !arrTemp.some(item=>item == row.eightdStatus) && row.isValid == 'Y'"
               type="primary" @click="dealBtn(row)">{{ h_i18n('59c1d28ffbf075894cb2684f702476c5') }}</h-button>
          </template>
        </el-table-column> 
        <el-table-column prop="" :label="h_i18n('f630b9a4da10f81b7bb1c75bf6345558')" width="80" class-name="btn_cell_style">
          <template #default="{row}">
            <h-button @click="openProcess(row)" type="warning">{{ h_i18n('f630b9a4da10f81b7bb1c75bf6345558') }}</h-button>
          </template>
        </el-table-column>
        <el-table-column prop="appealStatus" :label="h_i18n('37769e25fffd760203c860702167cd26')" width="100"></el-table-column>
        <el-table-column prop="" :label="h_i18n('91f741b843d731948ee812176615fd53')" class-name="btn_cell_style" width="250">
          <template #default="{row}">
            <template v-if="new Date(row.inputDate) < 1714492801000">
              <h-button type="primary" disabled>{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button type="danger" disabled>{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
            <template v-else>
              <h-button type="primary" @click="approval(row)" :disabled="row.appealStatus">{{ h_i18n('191a39634a0499cfbe8b6f5fc822d74b') }}</h-button>
              &nbsp;
              <h-button type="danger" @click="createAppeal(row)" :disabled="row.appealStatus">{{ h_i18n('ce6326e846e2c23e9a83fcfb9774685f') }}</h-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.current" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>
    </h-table-card>

    <h-dialog :title="h_i18n('ae762b31e735d05f32b0f8aef726da64')" class="process_dialog_style" :show="data.dialogOfProcess" width="70%" @close="data.dialogOfProcess = false, data.processData = []">
      <el-table :data="data.processData.slice((data.processPageNo-1)*10,data.processPageNo*10)"
          v-loading="data.processLoading" border size="small" height="540">
          <el-table-column prop="role" :label="h_i18n('8402fcdd8d97edd86fb1bc69059db687')" min-width="100"></el-table-column>
          <el-table-column prop="createDateTime" :label="h_i18n('19fcb9eb2594059036dfede5f4ec53e8')" min-width="170"></el-table-column>
          <el-table-column prop="flagVal" :label="h_i18n('54bbba803f13eaab0f5441d97b13247a')" min-width="100"></el-table-column>
          <el-table-column prop="approveDetail" :label="h_i18n('a6396f13c260444d561afaa9407467be')" width="200"></el-table-column>
        </el-table>
        <el-pagination background @current-change="processCurrentChange" v-model:currentPage="data.processPageNo"
                     :page-size="10" layout="total, prev, pager, next,jumper" :total="data.processPageTotal" :hide-on-single-page="data.processPageTotal <= 10">
      </el-pagination>
    </h-dialog>

  </h-list-page>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    keepalivestatus : 0,
    total:0,
    detailBtnRow:{},

    // 流程
    dialogOfProcess:false,
    processData:[],
    processLoading:false,

    processPageNo:1,
    processPageTotal:0,
    btnCodeList:[
    "mkhl_zg_zg_export",
    ],
    btnListOfSqm:[]
  })
  // 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_zg_zg_export":
    break;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
  case "mkhl_zg_zg_export":
    return 
  }
}
  const searchData = reactive({
    current:1,
    mtlNo:'',
  })

  // const arrTemp = [1293,1295,1357,1529,1530,1532,1534,1536,1556,1558]
  const arrTemp = [1292,1559]
  /**
 * 传高度
 */
 const changeMethod = () => {
  proxy.postThisPageHeight();
};
// 大部分页面通用函数
/**
 * 勾选操作
 * @param {*} rowArr 选中行
 */
const listCheckBoxChange = (rowArr) => {
  data.rowListOfCheck = rowArr
  // console.log("data.rowListOfCheck", data.rowListOfCheck);
};

// 清除按钮事件
const searchClear = (key) => {
  searchData[key] = undefined;
};
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};

// 两个模糊查询相关
const http = reactive({
  mtlSearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  MtlOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};
const clickSupplierCode = (row) => {
  searchData.supplyCode = row.supplyCode;
  plan.showSupplyPlan = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    proxy
      .$http({
        method: "POST",
        url: "/base/basicData/searchMaterielList",
        headers: { "content-type": "application/json" },
        data: {
          mtlNo: searchData.mtlNo,
        },
        cancelToken: http.mtlSearchHttp.token,
      })
      .then((res) => {
        data.mtlNoList = res.data.data;
        if (data.mtlNoList.length >= 600) {
          plan.MtlOver600 = true;
          data.mtlLoading = false;
        } else {
          plan.MtlOver600 = false;
          data.mtlLoading = false;
        }
      })
      .catch((e) => { });
  }
};
// 模糊查询结束

// 获取工厂小微
const getSybList = () => {
  proxy
    .$http({
      method: "get",
      url: "/base/OqcA/listSyb",
    })
    .then((res) => {
      data.sybAllList = res.data;
    });
};

// 时间范围选择
const TimeChange = (date, {start,end}) => {
  if (date) {
    searchData[start] = proxy.time(date[0]);
    searchData[end] = proxy.time(date[1]);
  } else {
    searchData[start] = undefined;
    searchData[end] = undefined;
  }
};

  /**
   * 查询列表
   */
  const getInfo = () => {
    // console.log("searchData:::::",searchData)
    data.tableLoading = true
    data.tableLoading = true;
    proxy.$http({
        method: "post",
        url: "/base/rejects8d/rejects8dList",
        data: {
          ...searchData,
          mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
          inputDate: undefined,
          size: 10,
          queryFlag:'sqm',
          supplyCode:data.supplyCode,
          appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
          eightdStatus: searchData.eightdStatus ? searchData.eightdStatus.split(",") :  undefined,
          happenAddress: searchData.happenAddress ? searchData.happenAddress.toString().split(",") :  undefined,
        },
      },
    ).then(res=>{
      data.dataOfTable = res.data.data.records
      data.total = res.data.data.total
      data.tableLoading = false;
    }).catch(err=>{
      data.total = 0
      data.dataOfTable = []
      data.tableLoading = false;
    })
  }
  /**
   * 详情按钮
   */
  const detailBtn = (row) => {
    // console.log("row::::::::",row)
    data.detailBtnRow = row
    proxy.$router.push({
      name: "Rejects8dDetail",
      query: {
        supplyCode:data.supplyCode,
        dataFrom:'sqm',
        eightdId: data.detailBtnRow.eightdId,
        sourceId:data.detailBtnRow.sourceId,
        kindType:'detail',
        trueName:data.trueName,
      }
    })
  }
  /**
   * 整改按钮
   */
  const dealBtn = (row) =>{
    // console.log("row::::::::",row)
    data.detailBtnRow = row
    if(!arrTemp.some(item => item == data.detailBtnRow.eightdStatus)){

      proxy.$router.push({
        name: "Rejects8dDetail",
        query: {
          supplyCode:data.supplyCode,
          dataFrom:'sqm',
          eightdId: data.detailBtnRow.eightdId,
          sourceId:data.detailBtnRow.sourceId,
          kindType : 'deal',
          trueName:data.trueName,
          userName:data.userName,
        }
      })
    }else{
      proxy.warning(h_i18n('d796b8fab939d645220fccb4613e501e'))
    }
  }
  /**
   * 导出 
   */
  const excleBtn = () => {
    if (data.total > 5000) {
      proxy.warning(
        { message: h_i18n('748c802d8fe36ada78520df791295747'), title: h_i18n('f148292ae0c683ca6fe4246350d309f6') },
        {
          confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback: (action) => { },
        }
      );
      return;
    }
    data.exportLoading = true;
    proxy.startLoading(h_i18n('44722d5fa7ea0b0e23bd9e0692358dc2'));
    proxy.httpFile(
      {
        method: "post",
        url: "/base/rejects8d/rejects8dListSqmExport",
        data: {
          ...searchData,
          mtlNo: searchData.mtlNo ? searchData.mtlNo : undefined,
          inputDate: undefined,
          size: undefined,
          current: undefined,
          queryFlag:'sqm',
          appealStatus: searchData.appealStatus ? searchData.appealStatus.split(",") : undefined,
          eightdStatus: searchData.eightdStatus ? searchData.eightdStatus.split(",") :  undefined,
          happenAddress: searchData.happenAddress ? searchData.happenAddress.toString().split(",") :  undefined,
        },
      },
      h_i18n('a9461c2f94d7f5c933ff2af4ec45d775')
    ).then(res=>{
      data.exportLoading = false;
    }).catch(err=>{
      data.exportLoading = false;
      proxy.closeLoading()
    })
  }

  /**
 * 打开流程 图表
 */
 const openProcess = (row) => {
  data.processLoading = true
  proxy.$http({
    url:'/base/rejects8d/selectProcessNodeList?eightdId='+row.eightdId,
    method:'get',
  }).then(res=>{
    if(res.data.code == '200'){
      data.processData = res.data.data
      data.processPageTotal = res.data.data.length
      data.dialogOfProcess = true
    }else{
      data.processData = []
      data.processPageTotal = 0
    }
  }).catch(err=>{
    data.processData = []
    data.processPageTotal = 0
  }).finally(()=>{
    data.processLoading = false
  })
}
// dialog table 翻页
const processCurrentChange = (v) => {
  data.processPageNo = v
}

// 认可 
const approval = (row) => {
  if(!row.eightdId){
    proxy.info(h_i18n('dfe56f61cf4d943cebb1374aa646a9bc'))
    return
  }
  data.eightdId = row.eightdId
  // data.approvalLoading = true
  proxy.warning({title:h_i18n('900c70fa5f7dbc014e6f762d5e0e885c'),message:h_i18n('99652ba7c48d6bba558e3b2182e9c31a'),confirmButtonText:h_i18n('e83a256e4f5bb4ff8b3d804b5473217a'),cancelButtonText:h_i18n('625fb26b4b3340f7872b411f401e754c'),
  callback: (action) => {
    if(action == 'confirm'){
      proxy.$http({
        method: "post",
        url: `/base/RefusalAppeal/update8d?eightdId=${data.eightdId}&appealStatus=${encodeURI('供方认可')}&usercode=${data.supplyCode}&username=${data.trueName}`,
      }).then(res=>{
        console.log(res)
        if (res.data.code == '0' && res.data.data == h_i18n('330363dfc524cff2488f2ebde0500896') && res.data.msg == '成功') {
          proxy.success(res.data.msg)
          getInfo()
        } else {
          proxy.info(res.data.msg)
        }
      }).catch(err=>{
        proxy.error(err)
      }).finally(()=>{
        data.eightdId = ''
        // data.approvalLoading = false
      })
    }else{
      // data.approvalLoading = false
    }
  }
})
}

// 申诉
const createAppeal = (row) => {
  proxy.$router.push({
    name: 'addAppeal',
    query: {
      eightdId:row.eightdId,
      dataFrom:"sqm",
      supplyCode: data.supplyCode,
      supplyName: data.supplyName,
      trueName: data.trueName,
      applyName: data.userName,
      userName: data.userName,
      kindType:'sqmAdd',
      comeFrom: '8D'
    }
  })
}
//发生节点：hmqm-server-test.qd-huangdao-test.haier.net/basicData/listBaseValues?valueTypeId=5
const getHappenAddress = () =>{
  proxy.$http({
    url:'/base/basicData/listBaseValues?valueTypeId=5',
    method:'get',
  }).then(res=>{
    if(res.data.code == 200){
      data.happenAddressList = res.data.data
    }
    // console.log(res)
  }).catch(err=>{
    proxy.info(err)
  }).finally(()=>{

  })
}

  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    if (route.query) {
      data.supplyCode = route.query.supplyCode;
      searchData.supplyCode = route.query.supplyCode;
      data.supplyName = route.query.supplyName;
      data.trueName = route.query.trueName;
      data.roleCode = route.query.roleCode;
      data.userName = route.query.userName;
      // data.searchStatus = route.query.searchStatus
      // if(data.searchStatus){
      //   searchData.eightdStatus = data.searchStatus
      // }
    }
    if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }
  getHappenAddress()
    getSybList()
    getInfo();
  })
  onActivated(() => {
  if (data.keepalivestatus == 0) {
    // console.log("首次打开");
    data.keepalivestatus ++ 
  } else {
    proxy.postThisPageHeight();
    // console.log("操作完之后打开");
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => { 
          proxy.$router.back()        
        },})
      return
    }
    getInfo()
  }
})
onDeactivated(() => {
})
</script>

<style lang="scss">
.Rejects8dList_style{
  .el-table td.textalignleft_style .cell {
    text-align: left !important;
  }
  .btn_cell_style{
    padding: 0px !important;
  }
  .haier-card .haier-card--body .el-table tr td {
    padding: 12px 0;
  }
}
.planHidden {
  display: none;
}
.process_dialog_style{
  .haier-dialog{
    top:5%;

  }
}
</style>